module.exports = __webpack_public_path__ + "media/images/bottles/bottle-orange-971c69f65bdd595d970bccc58af26e1c.png";